import React from 'react';
import PropTypes from 'prop-types';
import polylabel from 'polylabel';
import areapolygon from 'area-polygon';
import convert from 'convert-units';
import { decimalToFtInchesString } from '../../utils/xd-math';

const STYLE_TEXT = {
  textAnchor: 'middle',
  fontSize: '12px',
  fontFamily: '"Courier New", Courier, monospace',
  pointerEvents: 'none',
  fontWeight: 'bold',

  //http://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting-using-css
  WebkitTouchCallout: 'none', /* iOS Safari */
  WebkitUserSelect: 'none', /* Chrome/Safari/Opera */
  MozUserSelect: 'none', /* Firefox */
  MsUserSelect: 'none', /* Internet Explorer/Edge */
  userSelect: 'none'
};


export default function Area({layer, area, catalog, unit, displayUnit, scene}) {

  let rendered = catalog.getElement(area.type).render2D(area, layer, scene);
  let renderedAreaSize = null;
  let polygon = area.vertices.toArray().map(vertexID => {
    let {x, y} = layer.vertices.get(vertexID);
    return [x, y];
  });
  let polygonWithHoles = polygon;

  area.holes.forEach(holeID => {
    let polygonHole = layer.areas.get(holeID).vertices.toArray().map(vertexID => {
      let {x, y} = layer.vertices.get(vertexID);
      return [x, y];
    });
    polygonWithHoles = polygonWithHoles.concat(polygonHole.reverse());
  });

  let center = polylabel([polygonWithHoles], 1.0);

  if (area.selected || scene.xd_showAllMeasurements) {
    let areaSize = areapolygon(polygon, false);

    displayUnit = displayUnit || 'm';
    let displayArea = convert(areaSize).from(`${unit||'cm'}2`).to(`${displayUnit}2`);

    if (displayUnit === 'ft') {
      displayArea = `${decimalToFtInchesString(displayArea, { maxDecimalPlacesInches: 2 })}${String.fromCharCode(0xb2)}`;
    } else {
      displayArea = `${displayArea.toFixed(2)} ${displayUnit}${String.fromCharCode(0xb2)}`;
    }

    //subtract holes area
    area.holes.forEach(areaID => {
      let hole = layer.areas.get(areaID);
      let holePolygon = hole.vertices.toArray().map(vertexID => {
        let {x, y} = layer.vertices.get(vertexID);
        return [x, y];
      });
      areaSize -= areapolygon(holePolygon, false);
    });

    renderedAreaSize = (
      <text x="0" y="0" transform={`translate(${center[0]} ${center[1]}) scale(1, -1)`} style={STYLE_TEXT}>
        {displayArea}
      </text>
    )
  }

  let lineItemCount = area.lineItems.size || '';

  return (
    <g
      data-element-root
      data-prototype={area.prototype}
      data-id={area.id}
      data-selected={area.selected}
      data-layer={layer.id}
    >
      {rendered}
      {renderedAreaSize}
      <text x="0" y="0" transform={`translate(${center[0]} ${center[1] - 15}) scale(1, -1)`} style={STYLE_TEXT}>
        {lineItemCount}
      </text>
      <text x="0" y="0" transform={`translate(${center[0]} ${center[1] + 15}) scale(1, -1)`} style={STYLE_TEXT}>
        {area.name}
      </text>
    </g>
  )

}

Area.propTypes = {
  area: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  unit: PropTypes.string,
  displayUnit: PropTypes.string,
};
